<template>
  <div id="app"  style="margin: 0;">
    <div id="nav" style="margin: 0;">
     <!-- <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link> -->
    </div>
    <router-view />
  </div>
</template>

<script>
	localStorage.setItem('urlss','https://assets-api.liclouddata.com')
	// localStorage.setItem('urlss','http://asset.hxh.cab/')
</script>

<style lang="less">
	body{
		margin: 0;
	}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: 0;
}

</style>
